module.exports = __webpack_public_path__ + "static/img/otsar-large.20fde03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/otsar-large.jpg
// module id = Mjt1
// module chunks = 6